import { yup } from '@medely/ui-kit';
import { OTHER_REFERRAL_ID } from './constants';

export const accountInfoStepSchema = yup.object({
  first_name: yup.string().required('Required'),
  last_name: yup.string().required('Required'),
  nickname: yup.string().required('Required'),
  address_zip: yup.number().zip().required('Required'),
  phone_number: yup.string().phone().required('Required'),
  referral_source_id: yup.number().nullable(),
  other_referral_source: yup.string().when('referral_source_id', (referral_source_id, schema) => {
    return referral_source_id === OTHER_REFERRAL_ID
      ? schema.required('Required')
      : schema.notRequired();
  }),
});
